import React, { Component } from 'react'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'
import numeral from 'numeral'
import moment from 'moment';

import Box from '../components/Layout/Box'
import BoxButton from '../components/Layout/BoxButton'
import ButtonStrip from '../components/Layout/ButtonStrip'
import BoxSection from '../components/Layout/BoxSection'
import SelectorInput from '../components/Shared/SelectorInput'
import ModalSelectorFromList from '../components/Shared/ModalSelectorFromList'
import ModalAddServicio from '../components/CreacionSolicitudServicio/ModalAddServicio'
import AttachedFilesBox from '../components/Shared/AttachedFilesBox'
import ModalAddFile from '../components/Shared/ModalAddFile'

import { showModalSelector, selectFromSelector } from '../actions/common'
import {
    updateInputs,
    displayModalAddServicio,
    removeSolicitudServicioItems,
    toggleSelectAllSolicitudServicioItems,
    displayModalAddFile,
    toggleSelectAllSolicitudServicioFiles,
    uploadFile,
    addSolicitudServicioFile,
    createSolicitudServicio,
    removeSolicitudServicioFiles,
    enviarComentario,
    editarComentario,
    eliminarComentario
} from '../actions/creacionsolicitudservicio'

class CreacionSolicitudServicio extends Component {
    handleOpenSelector = (list) => {
        let columns = [
            { id: 1, caption: 'Identificacion', value: 'username', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'fullname', width: '70%' }
        ]
        const payload = {}
        const fn = (a) => {
            payload.path = list
            payload.value = a
            this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_SERVICIO', payload)
        }
        this.props.showModalSelector('Listado de usuarios', columns, '/usuarios/ldap', fn)
    }

	render() {
        const { creacionsolicitudservicio, enums } = this.props
        const boxActions = [
            <BoxButton key="ba[0][1]" name="floppy-o" onClick={ () => this.props.createSolicitudServicio() } title="Guardar" disabled={ creacionsolicitudservicio.get('btnSaveDisabled') } />
        ]
        
        const actionsSectionDetallesServicios = [
            <BoxButton key="ba[1][0]" size={14} contrast name="plus-circle" onClick={ e => this.props.displayModalAddServicio(true, 'Agregar Item', 'create') } title="Adicionar servicio"/>,
            <BoxButton key="ba[1][1]" size={14} contrast name="trash" onClick={ e => this.props.removeSolicitudServicioItems() } title="Eliminar servicio" danger disabled={ creacionsolicitudservicio.get('servicios').filter(x => x.get('selected')).count() === 0 }/>
        ]

		return (
            <div className="row" style={{ height: '100%', overflowX: 'hidden' }}>
                <div className="col-md-12" style={{ height: '100%' }}>
                    <Box title="Solicitud de servicios > Creación de solicitud">
                        <ButtonStrip actions={ boxActions } />
                        <div className="box-content">
                            <div>

                                <BoxSection title="Información básica">
                                    <div className="row">

                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label className="control-label">Solicitante</label>
                                                <input type="text" value={this.props.user.get('fullname') || ''} className="form-control input-sm" disabled />
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Correo</label>
                                                <input type="text" value={this.props.user.get('email') || ''} className="form-control input-sm" disabled />
                                            </div>
                                        </div>


                                        <div className="col-md-1">
                                            <div className="form-group">
                                                <label className="control-label">Extensión</label>
                                                <input type="text" value={this.props.user.get('extension') || ''} className="form-control input-sm" disabled />
                                            </div>
                                        </div>


                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Área</label>
                                                <input type="text" value={this.props.user.getIn(['area', 'nombre']) || ''} className="form-control input-sm" disabled />
                                            </div>
                                        </div>

                                    </div>


                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label className="control-label">Responsable de compras</label>
                                                <input className="form-control input-sm" type="text" value={enums.solicitudes.tipos[creacionsolicitudservicio.get('tipo')].responsable.fullname || ''} disabled />
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Correo</label>
                                                <input className="form-control input-sm" value={enums.solicitudes.tipos[creacionsolicitudservicio.get('tipo')].responsable.email || ''} disabled />
                                            </div>
                                        </div>

                                        <div className="col-md-1">
                                            <div className="form-group">
                                                <label className="control-label">Extensión</label>
                                                <input className="form-control input-sm" type="text" value={enums.solicitudes.tipos[creacionsolicitudservicio.get('tipo')].responsable.extension || ''} disabled />
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label className="control-label">Fecha de solicitud</label>
                                                <input className="form-control input-sm" value={moment().format('YYYY/MM/DD')} disabled />
                                            </div>
                                        </div>

                                    </div>
                                </BoxSection>



                                <BoxSection title="Información del servicio">

                                    <div className="row">
                                        <div className="col-md-10">
                                            <div className="form-group">
                                                <label className="control-label">Proyecto/Evento/Actividad</label>
                                                <input type="text" value={ creacionsolicitudservicio.get('proyecto_evento') } className="form-control input-sm" onChange={ e => this.props.updateInputs('proyecto_evento', e.target.value) }/>
                                            </div>
                                        </div>



                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label className="control-label">Fecha de entrega</label>
                                                <input type="date" value={ creacionsolicitudservicio.get('fecha_requerido') || '' } className="form-control input-sm" onChange={ e => this.props.updateInputs('fecha_requerido', e.target.value) }/>
                                            </div>
                                        </div>

                                    </div>

                                    
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Responsable gestión recibo</label>
                                                <SelectorInput value={ creacionsolicitudservicio.getIn(['responsable_recibo', 'fullname']) || '' } onClick={ () => this.handleOpenSelector('responsable_recibo') } onReset={ () => this.props.updateInputs('responsable_recibo', null) } />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label className="control-label">Area</label>
                                                <input type="text" value={ creacionsolicitudservicio.getIn(['responsable_recibo', 'area']) || '' } className="form-control input-sm" disabled/>
                                            </div>
                                        </div>
                                        <div className="col-md-1">
                                            <div className="form-group">
                                                <label className="control-label">Extensión</label>
                                                <input type="text" value={ creacionsolicitudservicio.getIn(['responsable_recibo', 'extension']) || '' } className="form-control input-sm" disabled/>
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Responsable gestión ingreso</label>
                                                <SelectorInput value={ creacionsolicitudservicio.getIn(['responsable_ingreso', 'fullname']) || '' } onClick={ () => this.handleOpenSelector('responsable_ingreso') } onReset={ () => this.props.updateInputs('responsable_ingreso', null) } />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label className="control-label">Area</label>
                                                <input type="text" value={ creacionsolicitudservicio.getIn(['responsable_ingreso', 'area']) || '' } className="form-control input-sm" disabled/>
                                            </div>
                                        </div>
                                        <div className="col-md-1">
                                            <div className="form-group">
                                                <label className="control-label">Extensión</label>
                                                <input type="text" value={ creacionsolicitudservicio.getIn(['responsable_ingreso', 'extension']) || '' } className="form-control input-sm" disabled/>
                                            </div>
                                        </div>
                                    </div>
                                </BoxSection>
                                <div className="separator"></div>
                                <BoxSection title="Detalles servicios" actions={ actionsSectionDetallesServicios }>

                                    <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-solicitudes">
                                        <thead>
                                            <tr>
                                                <th width="20px">
                                                    <input type="checkbox" style={{ verticalAlign: 'middle' }} onChange={ e => this.props.toggleSelectAllSolicitudServicioItems(e.target.checked) } checked={ creacionsolicitudservicio.get('servicios').filter(x => x.get('selected')).count() > 0 } />
                                                </th>
                                                <th style={{ width: '5%' }}>No.</th>
                                                <th style={{ width: '50%' }}>Descripción del servicio</th>
                                                <th style={{ width: '10%' }}>Cantidad</th>
                                                <th style={{ width: '35%' }}>Centro de costo</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                (creacionsolicitudservicio.get('servicios').count() > 0) ?
                                                    creacionsolicitudservicio.get('servicios').map((x, n) => {
                                                        return (
                                                            <tr key={ x.get('id') ? x.get('id') : x.get('guid') } className={ x.get('selected') ? 'info' : '' }>

                                                                <td><input type="checkbox" style={{ verticalAlign: 'middle' }} checked={ x.get('selected') } onChange={ (e) => this.props.updateInputs(`servicios.${n}.selected`, e.target.checked) } /></td>

                                                                <td className='LinkToEdit' style={{ textAlign: 'right' }} onClick={ () => this.props.displayModalAddServicio(true, 'Modificación de items', 'edit', n) }>{ n + 1 }</td>

                                                                <td>{ x.get('descripcion') }</td>

                                                                <td>{ x.get('cantidad') }</td>

                                                                <td>
                                                                {
                                                                    x.get('cencos').map(c => {
                                                                        return (
                                                                            <span key={ c.get('id') ? c.get('id') : c.get('guid') } className="label-cenco-dist" title={ c.getIn(['cenco', 'descripcion']) }>{ c.getIn(['cenco', 'codigo']) } - <strong>{ numeral(c.get('porcentaje') / 100).format('0%') }</strong></span>
                                                                        )
                                                                    })
                                                                }
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                :
                                                    <tr>
                                                        <td colSpan={ 5 } style={{ textAlign: 'center' }}>Para crear los servicios haga click en el botón <span style={{ color: '#888' }}><FontAwesome name="plus-circle" /></span></td>
                                                    </tr>
                                            }
                                        </tbody>
                                    </table>
                                </BoxSection>

                                <div className="separator"></div>

                                <BoxSection title="Observaciones">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <textarea type="text" className="form-control input-sm" rows={4} value={ creacionsolicitudservicio.get('observaciones') } onChange={ (e) => this.props.updateInputs('observaciones', e.target.value) } />
                                            </div>
                                        </div>
                                    </div>
                                </BoxSection>

                                <div className="separator"></div>
                                
                                <AttachedFilesBox
                                    files={ creacionsolicitudservicio.get('adjuntos') }
                                    removeFiles = { this.props.removeSolicitudServicioFiles }
                                    updateInputs = { this.props.updateInputs }
                                    obj={ creacionsolicitudservicio }
                                    check={ 'solicitud' }
                                />

                            </div>
                        </div>
                    </Box>
                </div>
                <ModalAddServicio />

                <ModalSelectorFromList />
                <ModalAddFile
                    action={ () => this.props.addSolicitudServicioFile() }
                />

            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        user: state.common.get('user'),
        creacionsolicitudservicio: state.creacionsolicitudservicio,
        enums: state.common.get('enums').toJS(),        
        responsable: state.common.getIn(['parametros', 'SOLICITUDES']) ? state.common.getIn(['parametros', 'SOLICITUDES']).filter(x => x.get('TIPO_SOLICITUD') == state.creacionsolicitudservicio.get('tipo')).first() : null
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
        showModalSelector: (title, fields, url, action) => dispatch(showModalSelector(title, fields, url, action)),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
        displayModalAddServicio: (show, title, mode, index) => dispatch(displayModalAddServicio(show, title, mode, index)),
        removeSolicitudServicioItems: () => dispatch(removeSolicitudServicioItems()),
        toggleSelectAllSolicitudServicioItems: (checked) => dispatch(toggleSelectAllSolicitudServicioItems(checked)),
        displayModalAddFile: (show, title, mode, index) => dispatch(displayModalAddFile(show, title, mode, index)),
        toggleSelectAllSolicitudServicioFiles: (checked) => dispatch(toggleSelectAllSolicitudServicioFiles(checked)),
		uploadFile: (file) => dispatch(uploadFile(file)),
		addSolicitudServicioFile: () => dispatch(addSolicitudServicioFile()),
        createSolicitudServicio: () => dispatch(createSolicitudServicio()),
        removeSolicitudServicioFiles: () => dispatch(removeSolicitudServicioFiles()),
        enviarComentario: () => dispatch(enviarComentario()),
        eliminarComentario: (guid) => dispatch(eliminarComentario(guid)),
        editarComentario: (guid) => dispatch(editarComentario(guid))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreacionSolicitudServicio)


// WEBPACK FOOTER //
// ./src/containers/CreacionSolicitudServicio.jsx